import React from "react";
import hero from "../../assets/images/Cloud-Storage.gif";
import shapeThree from "../../assets/images/shape/3.png";
import shapeFour from "../../assets/images/shape/4.png";
import { Link } from "react-scroll";

function HeroHomeEight() {
  return (
    <>
      <section className="appie-hero-area appie-hero-8-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="appie-hero-content appie-hero-content-8">
                <h1 className="appie-title">Robust IP Solutions</h1>
                <p>
                  Cloud/Server based communications and collaboration technologies for
                  organizations around the globe
                </p>
              </div>
              <div className="row pb-20 appie-hero-content-servics">
                {/* <div className="col-lg-3 col-md-6"> */}
                <ul>
                  <li>
                    <Link
                      to="solutions"
                      spy={true}
                      smooth={true}
                      offset={50}
                      duration={500}
                    >
                      <div
                        className="
                        pricing-one__single pricing-one__single_2
                        active
                        wow
                        animated
                        fadeInUp
                      "
                      >
                        <div className="pricig-heading">
                          <h4>IPTV</h4>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="solutions"
                      spy={true}
                      smooth={true}
                      offset={50}
                      duration={500}
                    >
                      <div
                        className="
                        pricing-one__single pricing-one__single_2
                        active
                        wow
                        animated
                        fadeInUp
                      "
                      >
                        <div className="pricig-heading">
                          <h4>Digital Signage</h4>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="solutions"
                      spy={true}
                      smooth={true}
                      offset={50}
                      duration={500}
                    >
                      <div
                        className="
                        pricing-one__single pricing-one__single_2
                        active
                        wow
                        animated
                        fadeInUp
                      "
                      >
                        <div className="pricig-heading">
                          <h4>Smart Booking</h4>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="solutions"
                      spy={true}
                      smooth={true}
                      offset={50}
                      duration={500}
                    >
                      <div
                        className="
                        pricing-one__single pricing-one__single_2
                        active
                        wow
                        animated
                        fadeInUp
                      "
                      >
                        <div className="pricig-heading">
                          <h4>AI and IoT</h4>
                        </div>
                      </div>
                    </Link>
                  </li>
                </ul>
                {/* </div> */}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="appie-hero-thumb-6">
                <div
                  className="thumb text-center wow animated fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="600ms"
                >
                  <img src={hero} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="home-8-shape-1">
          <img src={shapeThree} alt="" />
        </div>
        <div className="home-8-shape-5">
          <img src={shapeThree} alt="" />
        </div>
        <div className="home-8-shape-6">
          <img src={shapeThree} alt="" />
        </div>
        {/* <div className="home-8-shape-2">
          <img src={shapeFour} alt="" />
        </div> */}
      </section>
    </>
  );
}

export default HeroHomeEight;
